import { App } from 'vue';
import XEUtils from 'xe-utils';
import {
    VXETable,
    Header,
    Icon,
    Column,
    Table,
    Colgroup,
    Button,
    Input,
    Edit,
    Validator,
    Select,
    Radio,
    Pager,
    Filter,
} from 'vxe-table';
import zhCN from 'vxe-table/es/locale/lang/zh-CN';
import 'src/styles/style.scss';

// 全局默认参数
VXETable.setup({
    version: 0,
    zIndex: 100,
    table: {
        autoResize: true,
        showHeader: true,
        border: true,
    },
});

// 导入默认的国际化（如果项目中使用多语言，则应该导入到 vue-i18n 中）
VXETable.setup({
    i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhCN, key), args),
});

export function useTable(app: App) {
    app.use(Header)
        .use(Icon)
        .use(Column)
        .use(Table)
        .use(Colgroup)
        .use(Button)
        .use(Input)
        .use(Edit)
        .use(Validator)
        .use(Select)
        .use(Radio)
        .use(Pager)
        .use(Filter);
}
